<template>
  <VCard class="pa-3 mb-4">
    <VContainer>
      <VLayout d-flex wrap sm6>
        <BaseButton
          v-for="route of buttons"
          :key="route.title"
          :class="`dashboard-btn dashboard-btn-${routeToTestId(route)}`"
          :data-testid="`dashboard-btn-${routeToTestId(route)}`"
          v-bind="route"
          large
          >{{ route.title }}</BaseButton
        >
      </VLayout>
    </VContainer>
  </VCard>
</template>

<script>
import kebabCase from 'lodash/kebabCase'

export default {
  name: 'DashboardButtonGroup',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    /**
     * Convert route information to a consistent test ID
     * Uses lodash to convert to kebab-case (matches NavDropdownMenu.vue)
     */
    routeToTestId(route) {
      return kebabCase(route.to.replace(/^\//, ''))
    },
  },
}
</script>

<style lang="scss">
.dashboard-btn.v-btn--large {
  height: 55px;
}
</style>
